export const GLOBAL_STATE = 'StudentDashboard'

export const DASHBOARD_STUDENT = 'DASHBOARD_STUDENT' as const
export const DASHBOARD_V2_STUDENT = 'DASHBOARD_V2_STUDENT' as const
